import React, { useEffect, useState } from "react";
import TableContainer from "../../Component/TableContainer";
import { Box, Checkbox, IconButton, Typography, Paper, Grid, Button, Select, MenuItem, Switch, Autocomplete, CircularProgress, createFilterOptions, TextField, DialogTitle, DialogContent, DialogActions, Divider } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { masterAPI } from "../../Pages/Masters/dataConfig";
import { axiosPrivate } from "../../axios/axios";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
  RemoveRedEye,
} from "@mui/icons-material";
import { color } from "../../StyleData/Config";

import NormalTable from "../../Component/NormalTable";
import KPIHour from "../Dashboard/KPIHour";

import ResponsiveDialog from "../../Component/ResponsiveDialog";
const KPI = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [menusId, setMenusId] = useState([]);
  const [backupMenu, setBackUpMenu] = useState([]);
  const [rolesId, setRolesId] = useState([]);
  const [alreadyHaveMenu, setAlreadyHaveMenu] = useState([]);
  const [sel, setSel] = useState({
    autoRole: "",
    selectedRole: "",
    selectmenuId: [],
    selectedDetails: [],
    roleDetail: null,
  });
  const [kpiDialog, setKpiDialog] = useState({
    isOpen: false,
    kpiName: "",
    apiEndpoint: "",
  });

  useEffect(() => {
    getData();
  }, []);

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  const getData = async () => {
    const KPIData = [
      {
        KPIName: "Open WO",
      },
      {
        KPIName: "Overdue",
      },
      {
        KPIName: "Service Request",
      },
      {
        KPIName: "Cost",
      },
      {
        KPIName: "Mean Time Before Failure",
      },
      {
        KPIName: "Mean Time To Repair",
      },
      {
        KPIName: "PM Complaince",
      },
      {
        KPIName: "Failure Report",
      },
      {
        KPIName: "Problem Report",
      },
      {
        KPIName: "Causes Report",
      },
      {
        KPIName: "Corrective Report",
      },
      {
        KPIName: "Preventive Maintenance Hour",
      },
      {
        KPIName: "Predictive Maintenance Hour",
      },
      {
        KPIName: "Corrective Maintenance Hour",
      },
      {
        KPIName: "Proactive KPI",
      },
      {
        KPIName: "Reactive KPI",
      },
      {
        KPIName: "Schedule KPI",
      },
      {
        KPIName: "Backlog Size KPI",
      },
      {
        KPIName: "Accepted Work Percentage KPI",
      },
      {
        KPIName: "Rework Percentage KPI",
      },
    ];
    setMenusId(KPIData);
  };

  const handleKPIView = (kpiName) => {
    if (kpiName === "Preventive Maintenance Hour") {
      setKpiDialog({
        isOpen: true,
        kpiName: kpiName,
        apiEndpoint: masterAPI.KPIReport.getPreventiveMaintenanceHourKPIData,
      });
    }
  };

  const columns = [
    {
      accessor: "KPIName",
      Cell: ({ cell }) => {
        return (
          <Typography sx={{ fontSize: "inherit", fontWeight: "600" }}>
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const isPreventiveMaintenance =
          cell.row.original.KPIName === "Preventive Maintenance Hour";

        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton>
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                }}
              />
            </IconButton>
            <IconButton
              onClick={() =>
                isPreventiveMaintenance &&
                handleKPIView(cell.row.original.KPIName)
              }
            >
              <RemoveRedEye
                sx={{
                  fontSize: color.masterEditDelButton,
                  //color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          KPI
        </Typography>
      </Box>

      <Paper sx={{ p: 1 }}>
        <Grid container spacing={"1rem"}>
          <Grid item xs={12}>
            <NormalTable data={menusId} columns={columns} />
          </Grid>
        </Grid>
      </Paper>

      <ResponsiveDialog
        open={kpiDialog.isOpen}
        onClose={() => setKpiDialog({ ...kpiDialog, isOpen: false })}
        PaperProps={{
          sx: {
            maxWidth: { xs: "100vw", md: "90vw" },
            width: { xs: "100vw", md: "85vw" },
          },
        }}
      >
        <DialogTitle>{kpiDialog.kpiName}</DialogTitle>
        <Divider />
        <DialogContent sx={{ minHeight: "400px", p: 2 }}>
          {kpiDialog.apiEndpoint && (
            <KPIHour
              apiEndpoint={kpiDialog.apiEndpoint}
              title={kpiDialog.kpiName}
            />
          )}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setKpiDialog({ ...kpiDialog, isOpen: false })}
            variant="contained"
            sx={{ backgroundColor: "#2362B4", color: "white" }}
          >
            Close
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </>
  );
};

export default KPI;
